import * as React from 'react';
import { ControllerStateAndHelpers } from 'downshift';
import { AutoSuggestItem } from './Types';

export type AutoSuggestNoResultsTextProps = Pick<ControllerStateAndHelpers<AutoSuggestItem>, 'inputValue'>;

/**
 * Renders a message when no results are found for AutoSuggest components.
 *
 * @class AutoSuggestNoResultsText
 * @extends {React.Component<AutoSuggestNoResultsTextProps>}
 */
class AutoSuggestNoResultsText extends React.Component<AutoSuggestNoResultsTextProps> {
	public render() {
		const { inputValue } = this.props;

		if (inputValue) {
			return (
				<em data-testid="no-results-found">
					No results found for{' '}
					<strong>
						&quot;{inputValue}
						&quot;.
					</strong>
				</em>
			);
		}

		return <em>No results found.</em>;
	}
}

export default AutoSuggestNoResultsText;
